export const BUTTON_SIZE = {
  LARGE: 0,
  MEDIUM: 1,
  SMALL: 2,
};
